import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=0c8b536b"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"
import style0 from "./bar.vue?vue&type=style&index=0&id=0c8b536b&prod&lang=scss"
import style1 from "./bar.vue?vue&type=style&index=1&id=0c8b536b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports